import React, { useState, useEffect, useRef, memo } from 'react';

/**
 * UploadOrderDropdown
 * Самостоятельный компонент с собственным state для открытия/закрытия меню.
 * Вынесен из MaterialOrderPlanning чтобы setState меню не ре-рендерил тяжёлый родитель
 * и не вызывал задержку при открытии.
 */
const UploadOrderDropdown = memo(({
  onCreateOrder,
  onAddSmallBagsOrder,
  onDownloadExample,
  onReferenceGuide,
  onUpdateOrderStatus,
  onManageSuppliers,
  onAddSeedsOrder,
  onDownloadSeedsExample,
  onUpdateSeedsOrder,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const close = () => setIsOpen(false);

  return (
    <div className="upload-dropdown-wrapper" ref={wrapperRef}>
      <button
        className="btn btn__white_g"
        onClick={() => setIsOpen(prev => !prev)}
      >
        <i className="fa-solid fa-upload" style={{ marginRight: 6 }}></i>
        Upload Order
        <i className="fa-solid fa-chevron-down" style={{ marginLeft: 6, fontSize: '0.75em' }}></i>
      </button>

      {isOpen && (
        <div className="upload-dropdown-menu">
          <button
            className="upload-dropdown-item"
            onClick={() => { close(); onCreateOrder?.(); }}
          >
            <i className="fa-solid fa-cart-plus" style={{ marginRight: 8, width: 16 }}></i>
            Create New Order
          </button>
          <div className="upload-dropdown-divider" />
          <button
            className="upload-dropdown-item"
            onClick={() => { close(); onAddSmallBagsOrder(); }}
          >
            <i className="fa-solid fa-file-arrow-up" style={{ marginRight: 8, width: 16 }}></i>
            Add Materials Order
          </button>
          <button
            className="upload-dropdown-item"
            onClick={() => { close(); onDownloadExample(); }}
          >
            <i className="fa-solid fa-file-csv" style={{ marginRight: 8, width: 16 }}></i>
            File Example (CSV)
          </button>
          <button
            className="upload-dropdown-item"
            onClick={() => { close(); onUpdateOrderStatus(); }}
          >
            <i className="fa-solid fa-pen-to-square" style={{ marginRight: 8, width: 16 }}></i>
            Update Order Status
          </button>
          <button
            className="upload-dropdown-item"
            onClick={() => { close(); onReferenceGuide(); }}
          >
            <i className="fa-solid fa-circle-info" style={{ marginRight: 8, width: 16 }}></i>
            Reference Guide
          </button>
          <div className="upload-dropdown-divider" />
          <button
            className="upload-dropdown-item"
            onClick={() => { close(); onAddSeedsOrder?.(); }}
          >
            <i className="fa-solid fa-seedling" style={{ marginRight: 8, width: 16 }}></i>
            Add Seeds Order
          </button>
          <button
            className="upload-dropdown-item"
            onClick={() => { close(); onDownloadSeedsExample?.(); }}
          >
            <i className="fa-solid fa-file-csv" style={{ marginRight: 8, width: 16 }}></i>
            Seeds CSV Example
          </button>
          <button
            className="upload-dropdown-item"
            onClick={() => { close(); onUpdateSeedsOrder?.(); }}
          >
            <i className="fa-solid fa-pen-to-square" style={{ marginRight: 8, width: 16 }}></i>
            Update Seeds Order
          </button>
          <div className="upload-dropdown-divider" />
          <button
            className="upload-dropdown-item"
            onClick={() => { close(); onManageSuppliers?.(); }}
          >
            <i className="fa-solid fa-truck" style={{ marginRight: 8, width: 16 }}></i>
            Manage Suppliers
          </button>
        </div>
      )}
    </div>
  );
});

UploadOrderDropdown.displayName = 'UploadOrderDropdown';
export default UploadOrderDropdown;